export default __webpack_public_path__ + "static/media/institute-21-min.d132e978.webp";